// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1QFfB","rootSmall":"AddTileButton_rootSmall__3iNzI"};